export default {
  hero_title: '汇聚全球顶级联赛',
  hero_subtitle: '为体育爱好者提供一站式体育娱乐体验',
  hero_cta: '立即体验',
  hero_cta_secondary: '了解更多',
  category_title: '赛事分类',
  category_subtitle: '覆盖全球各大体育赛事，随时随地掌握赛况',
  stats_title: '平台数据',
  stats_subtitle: '海量用户信赖之选',
  stats_users: '活跃用户',
  stats_articles: '赛事资讯',
  stats_matches: '覆盖赛事',
  stats_countries: '覆盖国家',
  article_title: '热门资讯',
  article_subtitle: '掌握最新赛事动态与深度分析',
  faq_title: '常见问题',
  faq_subtitle: '快速了解开云体育平台',
  cta_title: '加入开云体育',
  cta_subtitle: '立即体验全球顶级体育赛事，感受竞技魅力',
  cta_button: '立即加入',
}